var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "q-edit-content q-checkbox" },
    [
      _c(
        "vh-checkbox-group",
        {
          staticClass: "checkbox-items",
          on: { change: _vm.change },
          model: {
            value: _vm.valArray,
            callback: function ($$v) {
              _vm.valArray = $$v
            },
            expression: "valArray",
          },
        },
        [
          _c(
            "draggable",
            {
              ref: "drag",
              attrs: { options: { handle: ".sort-item", animation: 200 } },
              on: {
                update: _vm.moved,
                start: function ($event) {
                  _vm.drag = true
                },
                end: function ($event) {
                  _vm.drag = false
                },
              },
              model: {
                value: _vm.value.detail.list,
                callback: function ($$v) {
                  _vm.$set(_vm.value.detail, "list", $$v)
                },
                expression: "value.detail.list",
              },
            },
            _vm._l(_vm.value.detail.list, function (item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "row",
                  class: { row_edit: _vm.value.ext.edit },
                },
                [
                  _c(
                    "vh-checkbox",
                    {
                      key: index,
                      staticClass: "q-select-item",
                      class: { display: !_vm.value.ext.edit },
                      attrs: {
                        disabled: _vm.isReplay,
                        label: item.key ? item.key : index,
                      },
                    },
                    [
                      _vm.value.ext.edit
                        ? _c("div", { staticClass: "sort-item" }, [
                            _c("img", {
                              staticStyle: { cursor: "move" },
                              attrs: {
                                width: "8",
                                src: "https://cnstatic01.e.vhall.com/upload/interacts/screen-imgs/202404/4e/00/4e0048314a03b356b433a19a7e41584a9065.png",
                                alt: "",
                              },
                            }),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.value.ext.edit
                        ? _c("com-input", {
                            staticClass: "chose-item",
                            class: { error: item.error },
                            attrs: {
                              placeholder: _vm.$t("form.form_1041"),
                              "max-length": 100,
                            },
                            on: {
                              focus: function ($event) {
                                return _vm.itemFocus(item)
                              },
                            },
                            model: {
                              value: item.value,
                              callback: function ($$v) {
                                _vm.$set(item, "value", $$v)
                              },
                              expression: "item.value",
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.value.ext.edit
                        ? _c("div", {
                            staticClass: "item-text check-item",
                            domProps: { textContent: _vm._s(item.value) },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  item.custom_opt == 1 &&
                  (_vm.valArray.includes(item.key) || _vm.value.ext.edit)
                    ? _c("com-input", {
                        staticClass: "otherItem",
                        attrs: {
                          "com-input": "",
                          placeholder: "请输入内容",
                          disabled: _vm.isReplay,
                          "show-length": !_vm.isReplay,
                          "max-length": 100,
                        },
                        model: {
                          value: _vm.otherValue,
                          callback: function ($$v) {
                            _vm.otherValue =
                              typeof $$v === "string" ? $$v.trim() : $$v
                          },
                          expression: "otherValue",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.value.ext.edit && _vm.value.detail.list.length > 2
                    ? _c(
                        "span",
                        {
                          staticClass: "remove",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.delItem(index)
                            },
                          },
                        },
                        [_c("i", { staticClass: "vh-icon-remove-outline" })]
                      )
                    : _vm._e(),
                ],
                1
              )
            }),
            0
          ),
        ],
        1
      ),
      _vm._v(" "),
      !_vm.value.ext.edit && _vm.errorTip
        ? _c("div", { staticClass: "error-msg" }, [
            _vm._v(_vm._s(_vm.errorTip) + "\n  "),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }